import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { ScrollArea } from "../../components/ui/scroll-area";
import { Avatar, AvatarImage, AvatarFallback } from "../../components/ui/avatar";
import { User } from "lucide-react";

export function TranscriptTab({ session }) {
  return (
    <Card className="premium-card">
      <CardHeader>
        <CardTitle className="text-base font-bold text-[#0B1F3B]">Conversation Transcript</CardTitle>
      </CardHeader>
      <CardContent>
        <ScrollArea className="h-[600px] pr-4">
          <div className="space-y-4">
            {session.messages?.map((msg, idx) => (
              <div 
                key={`${msg.role}-${idx}-${msg.timestamp || idx}`}
                className={`flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}
                data-testid={`eval-transcript-msg-${idx}`}
              >
                <div className={`flex items-start gap-3 max-w-[80%] ${msg.role === 'user' ? 'flex-row-reverse' : ''}`}>
                  {msg.role === 'assistant' ? (
                    <Avatar className="w-8 h-8 flex-shrink-0">
                      <AvatarImage src={session.persona?.avatar} />
                      <AvatarFallback className="bg-[#2563EB] text-white text-xs">{session.persona?.name?.[0]}</AvatarFallback>
                    </Avatar>
                  ) : (
                    <div className="w-8 h-8 bg-[#0B1F3B] rounded-full flex items-center justify-center flex-shrink-0">
                      <User className="w-4 h-4 text-white" />
                    </div>
                  )}
                  <div>
                    <p className={`text-xs text-slate-400 mb-1 ${msg.role === 'user' ? 'text-right' : ''}`}>
                      {msg.role === 'user' ? 'You (Advisor)' : session.persona?.name}
                    </p>
                    <div 
                      className={`p-4 rounded-2xl ${
                        msg.role === 'user' 
                          ? 'bg-[#0B1F3B] text-white rounded-br-md' 
                          : 'bg-[#2563EB]/5 text-[#0B1F3B] rounded-bl-md border border-[#2563EB]/10'
                      }`}
                    >
                      <p className="text-sm leading-relaxed">{msg.content}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
}
